import React from 'react';
import { StarIcon } from 'lucide-react';
const testimonials = [{
  name: 'María Fernanda López',
  age: 34,
  role: 'docente de 3er grado',
  city: 'Córdoba',
  text: 'Me salvó la vida. Siempre perdía los domingos buscando qué hacer para las fechas patrias. Ahora abro el pack, elijo la actividad y listo. Ahorré muchísimo tiempo y las clases salen hermosas.'
}, {
  name: 'Carolina Ruiz',
  age: 41,
  role: 'docente de 5to grado',
  city: 'Rosario',
  text: 'Lo que más valoro es tener todo el material organizado en un solo lugar. Las explicaciones son súper claras para los chicos y las actividades son diferentes a lo que se encuentra siempre en internet.'
}, {
  name: 'Luciana Gómez',
  age: 29,
  role: 'docente de 1er grado',
  city: 'Buenos Aires',
  text: 'Soy docente nueva y me daba mucho miedo el tema de los actos y las efemérides. Este pack me dio una seguridad increíble. Los discursos de los bonos son preciosos, me felicitaron en el último acto.'
}];
export function TestimonialsSection() {
  return <section className="py-6 px-4 bg-gray-50" data-id="element-318">
      <div className="max-w-6xl mx-auto" data-id="element-319">
        <h2 className="text-[20px] font-black mb-5 text-center text-[#F9327E]" data-id="element-320">
          Lo que dicen otras docentes
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-321">
          {testimonials.map((t, index) => <div key={index} className="bg-white p-4 rounded-2xl shadow-md border border-gray-100 flex flex-col" data-id="element-322">
              <div className="flex mb-2" data-id="element-323">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" data-id="element-324" />)}
              </div>
              <p className="text-gray-700 italic mb-3 flex-grow" data-id="element-325">"{t.text}"</p>
              <div className="border-t pt-3 mt-auto" data-id="element-326">
                <p className="font-bold text-gray-900" data-id="element-327">
                  {t.name}, {t.age} años
                </p>
                <p className="text-sm text-gray-500" data-id="element-328">{t.role}</p>
                <p className="text-sm text-gray-500" data-id="element-329">{t.city}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}